import { useLocation } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import { PATH_PAGE } from '../../routes/paths';

const useClientAccess = () => {
  const { env, hasClientRole, user } = useAuth();
  const { pathname } = useLocation();

  const {
    settings: {
      cli_access_bills: cliAccessInvoices,
      cli_access_quotes: cliAccessQuotes,
      cli_access_provider: cliAccessProvider,
      cli_access_schedule_site: cliAccessScheduleSite,
      cli_access_sites: cliAccessSites
    }
  } = env;

  const {
    general: {
      site: { siteSheet, siteSchedule }
    },
    client: { invoices, provider, quotes }
  } = PATH_PAGE;

  // * Client

  if (
    hasClientRole &&
    ((!cliAccessScheduleSite && pathname.includes(siteSchedule)) ||
      ((!cliAccessSites || user?.forbiddenPages?.includes('VOSINF')) && pathname.includes(siteSheet)) ||
      ((!cliAccessProvider || user?.forbiddenPages?.includes('NOSINF')) && pathname.includes(provider)) ||
      ((!cliAccessInvoices || user?.forbiddenPages?.includes('FACTURES')) && pathname.includes(invoices)) ||
      ((!cliAccessScheduleSite || user?.forbiddenPages?.includes('PLANNING')) && pathname.includes(siteSchedule)) ||
      ((!cliAccessQuotes || user?.forbiddenPages?.includes('DEVIS')) && pathname.includes(quotes)))
  ) {
    return false;
  }

  return true;
};

export default useClientAccess;
